import { render, staticRenderFns } from "./block-document-share-link-socials.vue?vue&type=template&id=c2d95cea&scoped=true&lang=pug"
import script from "./block-document-share-link-socials.vue?vue&type=script&lang=js"
export * from "./block-document-share-link-socials.vue?vue&type=script&lang=js"
import style0 from "./block-document-share-link-socials.vue?vue&type=style&index=0&id=c2d95cea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d95cea",
  null
  
)

export default component.exports